import { Tag } from 'antd'

const ANTDTag = props => {
  return <Tag {...props} />
}

export default ANTDTag
